import moment from 'moment/moment';
import getValidationRules from '../services/validationRules';
import { MAPPED_DOCUMENTS } from '../store/passport/permittedDocuments';
import { MAIN_DATA_FIELD_NAMES } from '../constants/citizenship';
import { ACT_RECORD_FIELD_NAMES } from '../constants/actRecord';
import { DATE_FORMAT } from './date';

const validator = (
  formData,
  documentType,
  actRecordVersion,
  withBirthRegPlace
) => {
  const formObject = formData ? formData : {};
  const validateRules = getValidationRules(
    documentType,
    actRecordVersion,
    withBirthRegPlace
  );
  const validateObj = { valid: !!documentType, errors: {} };

  validateRules.forEach(params => {
    const {
      field,
      required,
      pattern,
      length,
      maxLength,
      minLength,
      date,
      dateRange,
      minDate,
      maxDate,
      messageRequired,
      messageFormat,
      messageLength
    } = params;
    const fieldValue = formObject[field]?.hasOwnProperty('value')
      ? formObject[field].value
      : formObject[field];

    if (field === 'birthdate' || field === 'dateOfIssue' || field === 'date') {
      const parseFieldValue = moment(fieldValue, DATE_FORMAT, true);

      if (!parseFieldValue) {
        return false;
      }

      if (fieldValue && date && !parseFieldValue.isValid()) {
        validateObj.valid = false;
        validateObj.errors[field] = messageRequired;
      }

      if (
        fieldValue &&
        dateRange &&
        !parseFieldValue.isBetween(minDate, maxDate)
      ) {
        validateObj.valid = false;
        validateObj.errors[field] = messageFormat;
      }

      if (fieldValue && field === 'dateOfIssue') {
        const isPassportRf =
          formObject.documentType === MAPPED_DOCUMENTS.PASSPORT_RF;

        const diffDurationYears = parseFieldValue.diff(
          formObject['birthdate'],
          'years'
        );
        if (diffDurationYears < 14 && isPassportRf) {
          validateObj.valid = false;
          validateObj.errors[field] = 'Некорректная дата';
        }

        const diffDurationDays = parseFieldValue.diff(
          formObject['birthdate'],
          'days'
        );
        if (diffDurationDays < 0 && !isPassportRf) {
          validateObj.valid = false;
          validateObj.errors[field] = 'Некорректная дата';
        }
      }
    }

    if (formObject.birthdate) {
      if (
        withBirthRegPlace &&
        field === MAIN_DATA_FIELD_NAMES.birthRegistrationPlace &&
        !fieldValue
      ) {
        validateObj.valid = false;
        validateObj.errors[field] = messageRequired;
      }
    }

    if (field === ACT_RECORD_FIELD_NAMES.regPlace) {
      const regPlaceSearchInitiated =
        (fieldValue.text || fieldValue).length > 2;
      const regPlaceSelectedFromList = !!fieldValue.value;

      if (!regPlaceSearchInitiated) {
        validateObj.valid = false;
        validateObj.errors[field] = messageRequired;
      }

      if (regPlaceSearchInitiated && !regPlaceSelectedFromList) {
        validateObj.valid = false;
        validateObj.errors[field] = 'Необходимо выбрать из списка орган ЗАГС';
      }
    }

    if (pattern && !new RegExp(pattern, 'gi').test(fieldValue)) {
      validateObj.valid = false;
      validateObj.errors[field] = messageFormat;
    }

    if (length && fieldValue && fieldValue.length !== length) {
      validateObj.valid = false;
      validateObj.errors[field] = messageFormat;
    }

    if (minLength && fieldValue && fieldValue.length < minLength) {
      validateObj.valid = false;
      validateObj.errors[field] = messageLength;
    }

    if (maxLength && fieldValue && fieldValue.length > maxLength) {
      validateObj.valid = false;
      validateObj.errors[field] = messageLength;
    }

    if (required) {
      const valueText = fieldValue?.hasOwnProperty('text')
        ? fieldValue.text
        : fieldValue;

      if (!valueText) {
        validateObj.valid = false;
        validateObj.errors[field] = messageRequired;
      }
    }
    return undefined;
  });

  return validateObj;
};

export default validator;
